import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import store from "./store/store";
import App from "./App";
import { FoodProvider } from "./contexts/food-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <FoodProvider>
        <App />
      </FoodProvider>
    </Provider>
  </React.StrictMode>
);
